export default __webpack_public_path__ + "locales/vi/SingleSignOn.json?hash=8e2dc2bd0ef136a372fed271c69e6107";